import { createAction } from '../../../core/helpers'

import { FETCH_USER_DETAILS, FETCH_USERS } from '../action-types'

export const cleanupFetchUserDetails = createAction(FETCH_USER_DETAILS.CLEANUP)
export const cleanupFetchUsers = createAction(FETCH_USERS.CLEANUP)
